import ActionTypes from '../actions/types';
import { defaultState } from './defaultState';
import { setState } from './helper';

const initialState = defaultState.user;

export default (state = initialState, action) => {

  const {
    type,
    oauthToken,
    oauthTokenSecret,
    profileId,
    firstName,
    lastName,
    organizations,
    email,
    avatar
  } = action;

  switch (type) {
    case ActionTypes.STORE_REQUEST_TOKEN:
      return {
        ...state,
        oauthToken,
        oauthTokenSecret,
      };
    case ActionTypes.STORE_ACCESS_TOKEN:
      return {
        ...state,
        oauthToken,
        oauthTokenSecret,
        profileId,
      };
    case ActionTypes.SET_USER_INFO:
      return {
        ...state,
        firstName,
        lastName,
        organizations,
        email,
        avatar
      };

    case ActionTypes.SET_USER_DATA_FETCH_TIMESTAMP:
      return setState(state, action, 'userDataFetchedAt');

    case ActionTypes.LOGOUT_USER:
      return initialState;

    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js